var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data_title"},[_c('span',{staticClass:"maker"}),_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }